export default [
    {
        id: 6,
        name: 'Total ingresos',
        formula: '(evalResult = this.form.if.incomes.total)',
        info:'Total ingresos',
    },
    {
        id: 7,
        name: 'Total Egresos UF',
        formula: '(evalResult = this.form.if.expenses.total)',
        info:'Total Egresos UF',
    },
    {
        id: 8,
        name: 'Excedente',
        formula: '(evalResult = this.form.if.surplus)',
        info:'Excedente',
    },
    {
        id: 5,
        name: 'Capacidad de pago (75%)',
        formula: '(evalResult = this.form.if.surplus*0.75)',
        info:'Excedente * 0.75',
    },
]
